import React, { Fragment, FunctionComponent } from 'react'

import { Legend } from '@/atoms/typography'
import { FieldArrayWrapper, FieldWrapper, FormControl } from '@/components/form-elements'
import { getFieldCount } from '@/helpers/utils'
import { Field, FormControlType } from '@/models/common'
import { Space } from '@/styles'

interface Props {
  values: Array<string | number>
  fieldArrayTitle?: string
  fields: ((index?: number) => Array<Field>) | Array<Field>
}

const FieldArrayPreview: FunctionComponent<Props> = ({ fieldArrayTitle, values, fields }: Props) => {
  const getFields = (index: number): Array<Field> => {
    if (typeof fields === 'function') {
      return fields(index)
    }
    return fields
  }

  return (
    <Fragment>
      {values.map((val, index) => (
        <FieldArrayWrapper key={index}>
          {fieldArrayTitle && (
            <Legend mb={Space.S12} px={Space.S12} width={1}>
              {fieldArrayTitle} {index + 1}
            </Legend>
          )}

          {getFields(index).map(({ name, label, valueFormat, color, width, hideField, formatValue, decimalScale, currency }) => {
            if (hideField) return null
            const value = formatValue ? formatValue(val[name]) : val[name]
            const formattedFieldLabel = fieldArrayTitle ? label : `${label} ${getFieldCount(index, values.length)}`
            return (
              <FieldWrapper width={width} key={name ?? index} mb={Space.S12}>
                <FormControl
                  label={label ? formattedFieldLabel : undefined}
                  control={FormControlType.DISPLAY}
                  fieldValue={value}
                  valueFormat={valueFormat}
                  decimalScale={decimalScale}
                  color={color}
                  currency={currency}
                />
              </FieldWrapper>
            )
          })}
        </FieldArrayWrapper>
      ))}
    </Fragment>
  )
}

export default FieldArrayPreview
